module.exports = __webpack_public_path__ + "img/Sydney1.8ca36b9e.jpg";